export default {
    add: 'license/add',
    tarrifs: 'license/tarrifs',
    list: 'license/list',
    details: 'license/details',
    groups: 'license/groups',
    listForGroup: 'license/listForGroup',
    testResults: 'license/testResults',
    testChange: 'license/testChange',
    setStatus: 'license/setStatus',
    setTarrif: 'license/setTarrif'
}